module.exports = __webpack_public_path__ + "img/eliza5.c2c7f96d.png";